import i18n from '../i18n'
export default {
  install: function (Vue) {
    const NUTRIENTS = [
      {
        id: 1,
        color: "#f8b800",
        name: "label.staple",
        icon: require('@/assets/img/icons/staple.svg')
      },
      {
        id: 2,
        color: "#c84283",
        name: "label.main",
        icon: require('@/assets/img/icons/main.svg')
      },
      {
        id: 3,
        color: "#008442",
        name: "label.sub",
        icon: require('@/assets/img/icons/sub.svg')
      },
      {
        id: 4,
        color: "#0db8d9",
        name: "label.dairy",
        icon: require('@/assets/img/icons/dairy.svg')
      },
      {
        id: 5,
        color: "#ea5419",
        name: "label.fruits",
        icon: require('@/assets/img/icons/fruits.svg')
      },
      {
        id: 6,
        color: "#a2ca0e",
        name: "label.sweets",
        icon: require('@/assets/img/icons/sweets.svg')
      },
      {
        id: 7,
        color: "#2660ac",
        name: "label.drink",
        icon: require('@/assets/img/icons/drink.svg')
      }
    ]
    Vue.prototype.$nutrients = {
      getColor (id) {
        let result = '';
        NUTRIENTS.forEach((val) => {
          if (id === val.id) {
            result = val.color
            return
          }
        })
        return result
      },
      getIcon (id) {
        let result = '';
        NUTRIENTS.forEach((val) => {
          if (id === val.id) {
            result = val.icon
            return
          }
        })
        return result
      },
      getOptions () {
        const result = []
        NUTRIENTS.forEach((val) => {
          result.push({ id: val.id, label: i18n.t(val.name) })
        })
        return result
      },
      getData (id) {
        let result = null
        NUTRIENTS.forEach((val) => {
          if (id === val.id) {
            result = { id: val.id, name: val.name }
          }
        })
        return result
      }
    }
  }
}